import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

import { EndpointsService, FilterService, DateHelperService } from '../core/services';
import { IDashBoardAdminChartDetailsWithProvider, IDashBoardAdminChartDetails, ICampaignChart } from './dasboard-admin-chart-details.model';
import { DashboardFilterModel } from "./dashboard-filter-model";
import { UniqueModel } from "./uniques/unique.model";

@Injectable()
export class DashBoardAdminService {
    constructor(private http: Http,
        private endpointsService: EndpointsService,
        private dateHelper: DateHelperService,
        private filterService: FilterService) {
    }

    public getVersionNumber(): Observable<string> {
        let url = this.endpointsService.GET_VERSION_NUMBER;
        return this.http.get(url)
            .catch(this.handleError);
    }

    public getDetailsByProvider(filters: DashboardFilterModel): Observable<IDashBoardAdminChartDetailsWithProvider> {
        let url = this.getUrlWithProvider(filters);
        return this.http.get(url)
            .map((response: Response) => <IDashBoardAdminChartDetailsWithProvider>response.json())
            .catch(this.handleError);
    }

    public getDetailsByProviderForToday(filters: DashboardFilterModel): Observable<IDashBoardAdminChartDetailsWithProvider> {
        let url = this.getUrlWithProvider(filters, true);
        return this.http.get(url)
            .map((response: Response) => <IDashBoardAdminChartDetailsWithProvider>response.json())
            .catch(this.handleError);
    }

    public getDetails(filters: DashboardFilterModel): Observable<IDashBoardAdminChartDetails> {
        let url = this.getUrl(filters);
        return this.http.get(url)
            .map((response: Response) => <IDashBoardAdminChartDetails>response.json())
            .catch(this.handleError);
    }

    public getDetailsForToday(filters: DashboardFilterModel): Observable<IDashBoardAdminChartDetails> {
        let url = this.getUrl(filters, true);
        return this.http.get(url)
            .map((response: Response) => <IDashBoardAdminChartDetails>response.json())
            .catch(this.handleError);
    }

    public getCampaignDetails(filters: DashboardFilterModel): Observable<ICampaignChart> {
        let allPublishersSelected: boolean = false;
        if (filters.publisherIds.length === this.filterService.getPublisherIds().length)
            allPublishersSelected = true;
        return this.http.get(`${this.endpointsService.GET_CHART_CAMPAIGNS_URL}?publisherIds=${filters.publisherIds}&ProviderIds=${filters.providerIds}&countryIds=${filters.countryIds}&allPublishersSelected=${allPublishersSelected}`)
            .map((response: Response) => <ICampaignChart>response.json())
            .catch(this.handleError);
    }

    public getUniqueRequests(publisherIds: number[]): Observable<UniqueModel> {
        let allPublishersSelected: boolean = false;
        if (publisherIds.length === this.filterService.getPublisherIds().length)
            allPublishersSelected = true;
        return this.http.get(`${this.endpointsService.GET_UNIQUE_REQUESTS_URL}?publisherIds=${publisherIds}&allPublishersSelected=${allPublishersSelected}`)
            .map((response: Response) => <UniqueModel>response.json())
            .catch(this.handleError);
    }

    private handleError(error: Response) {
        return Observable.throw(error.json().error || 'Server Error');
    }

    private getUrlWithProvider(filters: DashboardFilterModel, forToday: boolean = false): string {
        if (forToday)
            return `${this.endpointsService.GET_CHART_DETAILS_BY_PROVIDERS_FOR_TODAY_URL}?publisherIds=${filters.publisherIds}&providerIds=${filters.providerIds}&countryIds=${filters.countryIds}`;
        let url = `${this.endpointsService.GET_CHART_DETAILS_BY_PROVIDERS_URL}?publisherIds=${filters.publisherIds}&providerIds=${filters.providerIds}&countryIds=${filters.countryIds}`;
        let startDate = this.dateHelper.formatDate(filters.startDate);
        let endDate = this.dateHelper.formatDate(filters.endDate);
        return `${url}&startDateUtc=${startDate}&endDateUtc=${endDate}`;
    }

    private getUrl(filters: DashboardFilterModel, forToday: boolean = false): string {
        let url: string = '';
        if (forToday)
            url = `${this.endpointsService.GET_CHART_DETAILS_FOR_TODAY_URL}?publisherIds=${filters.publisherIds}&countryIds=${filters.countryIds}`;
        else
            url = `${this.endpointsService.GET_CHART_DETAILS}?publisherIds=${filters.publisherIds}&countryIds=${filters.countryIds}`;
        let startDate = this.dateHelper.formatDate(filters.startDate);
        let endDate = this.dateHelper.formatDate(filters.endDate);
        return `${url}&startDateUtc=${startDate}&endDateUtc=${endDate}`;
    }
}


// WEBPACK FOOTER //
// ./src/app/dashboard/dashboard-admin.service.ts